export default __webpack_public_path__ + "share-icon.3fb0840898403c434617.png";